import { MKEvent, Result } from './types.ts';

export const Origin = {
  HTML: 0,
  NATIVE: 1,
} as const;
export type Origin = typeof Origin[keyof typeof Origin];

export const DataFlow = {
  N2H: 0,
  N2H2N: 1,
  H2N: 2,
} as const;
export type DataFlow = typeof DataFlow[keyof typeof DataFlow];

// ----------------------
// DataFlow.N2H2N actions
// ----------------------

export const reply = <T extends object>(
  messageId: string,
  result: Result<T>,
) => ({
  messageId,
  origin: Origin.HTML,
  dataFlow: DataFlow.N2H2N,
  payload: result,
});

// ----------------------
// DataFlow.H2N actions
// ----------------------
export const notify = (
  payload: MKEvent,
) => ({
  origin: Origin.HTML,
  dataFlow: DataFlow.H2N,
  payload,
});

// ------------
// Action Types
// ------------
export type Action =
  // DataFlow.N2H2N actions
  | ReturnType<typeof reply>
  // DataFlow.H2N actions
  | ReturnType<typeof notify>;
